import React, { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import EditText from '../../../../../components/base/edit-text/edit-text';
import i18n from '../../../../../translations/strings';
import Button from '../../../../../components/base/button/button';
import { CustomerDataFormStyled } from './customer-data-form.styled';

const CustomerDataForm = (props: any) => {

  const {
    control,
    formState: { errors, isValid },
    register,
    handleSubmit,
    reset,
  } = useFormContext();


  useEffect(() => {
    if (props.resetForm) {
      props.setResetForm()
      reset( {
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
      });
    }
  }, [props.resetForm]);

  return (
    <>
    <CustomerDataFormStyled.Container container>
      <CustomerDataFormStyled.ContainerItemGrid item md={5} xs={12}>
        <Controller
          control={control}
          rules={{
            required: true,
          }}
          render={({ field: { onChange, value } }) => (
            <EditText
              error={errors?.first_name?.message?.toString()}
              fullWidth
              {...register('first_name')}
              defaultValue={value}
              placeholder={i18n.t('adminNewReservation.firstName')}
              onChange={onChange}
              label={i18n.t('adminNewReservation.firstName')}
            />
          )}
          name="first_name"
        />
      </CustomerDataFormStyled.ContainerItemGrid>
      <CustomerDataFormStyled.ContainerItemGrid item md={5} xs={12}>
        <Controller
          control={control}
          rules={{
            required: true,
          }}
          render={({ field: { onChange, value } }) => (
            <EditText
              error={errors?.last_name?.message?.toString()}
              fullWidth
              {...register('last_name')}
              defaultValue={value}
              placeholder={i18n.t('adminNewReservation.lastName')}
              onChange={onChange}
              label={i18n.t('adminNewReservation.lastName')}
            />
          )}
          name="last_name"
        />
      </CustomerDataFormStyled.ContainerItemGrid>
      <CustomerDataFormStyled.ContainerItemGrid item md={5} xs={12}>
        <Controller
          control={control}
          rules={{
            required: true,
          }}
          render={({ field: { onChange, value } }) => (
            <EditText
              error={errors?.email?.message?.toString()}
              fullWidth
              {...register('email')}
              defaultValue={value}
              placeholder={i18n.t('common.email')}
              onChange={onChange}
              label={i18n.t('common.email')}
            />
          )}
          name="email"
        />
      </CustomerDataFormStyled.ContainerItemGrid>
      <CustomerDataFormStyled.ContainerItemGrid item md={5} xs={12}>
        <Controller
          control={control}
          rules={{
            required: true,
          }}
          render={({ field: { onChange, value } }) => (
            <EditText
              error={errors?.phone_number?.message?.toString()}
              fullWidth
              {...register('phone_number')}
              defaultValue={value}
              placeholder={i18n.t('adminNewReservation.phoneNumber')}
              onChange={onChange}
              label={i18n.t('adminNewReservation.phoneNumber')}
            />
          )}
          name="phone_number"
        />
      </CustomerDataFormStyled.ContainerItemGrid>
    </CustomerDataFormStyled.Container>
      <CustomerDataFormStyled.ContainerButton>
        <Button
          onClick={handleSubmit(props.onSubmit, props.onError)}
          label={i18n.t('adminNewReservation.continue')}
          disabled={props.loading || !isValid}
        />
      </CustomerDataFormStyled.ContainerButton>
    </>
  );
};

export default CustomerDataForm;
